const gridProfile = {
  gridProfile: {
    pageHeader: 'Profil sieci',
    name: 'Imię i nazwisko',
    description: 'Opis',
    createdBy: 'Stworzone przez',
    noGrid: '** Brak dostępnych sieci **',
    grids: 'Sieci'
  }
};

export default gridProfile;
